
const OrderFields = ({ width = 17, height = 24 }) => (
	<svg width={width} height={height} viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10.1667 1.5V9.57692H16L6.83333 22.5V14.4231H1L10.1667 1.5Z" stroke="currentColor" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export default OrderFields;